export const defaultBanner = {
  id: '',
  title: 'home.default_banner.title',
  description: 'home.default_banner.description',
  callToAction: {
    route: 'home.default_banner.link',
    text: 'global.button.download_app'
  },
  backgroundColor: '#D1EDD7'
};
